import React from "react"
import { TERM_EXTERNAL } from "components/pages/others/external/const"
import { map, includes, reject, isEmpty, findKey } from "lodash"

import dayjs from "dayjs"
import { resultObj } from "components/atoms/chart/logic/chartProvider"

export type termType = {
  id: number
  displayTitle: string
  key: string
}

export type requestParamType = {
  Symbol: string
  Exchange: number
  SecurityType: number
}

export type PropsType = {
  data: resultObj
  headerOnly: boolean
  legValue?: number
}

export const chartLegMenu = map(TERM_EXTERNAL, (term: termType) => {
  return { id: term.id, name: term.displayTitle, key: term.key }
})

export const getTargetMonth = (
  legList: object,
  targetDay: string,
  monthValue: number
) => {
  const targetNum = findKey(legList, (list: Array<string>) => {
    return includes(
      [
        dayjs(targetDay)
          .subtract(monthValue, "month")
          .format("YYYYMMDD"),
      ],
      String(list[0]).substr(0, 8)
    )
  })
  return (
    targetNum ||
    findKey(legList, (list: Array<string>) => {
      return includes(
        [
          dayjs(targetDay)
            .subtract(monthValue, "month")
            .format("YYYYMM"),
        ],
        String(list[0]).substr(0, 6)
      )
    })
  )
}

export const getLegList = (data: resultObj, type: termType) => {
  const legList = data.Chart.LegList
  const newDataTime = !isEmpty(legList) ? legList[legList.length - 1][0] : ""
  const checkDateToDay = String(newDataTime).substr(0, 8)
  switch (type.id) {
    case TERM_EXTERNAL[0].id:
      return reject(legList, (list: Array<string>) => {
        return list[0].indexOf(checkDateToDay)
      })
    case TERM_EXTERNAL[1].id:
      const targetOneMonth = getTargetMonth(legList, checkDateToDay, 1)
      return reject(legList, (data, key: number) => {
        return Number(targetOneMonth) > key
      })
    case TERM_EXTERNAL[2].id:
      const targetThreeMonth = getTargetMonth(legList, checkDateToDay, 3)
      return reject(legList, (data, key: number) => {
        return Number(targetThreeMonth) > key
      })
    case TERM_EXTERNAL[3].id:
      const targetSixMonth = getTargetMonth(legList, checkDateToDay, 6)
      return reject(legList, (data, key: number) => {
        return Number(targetSixMonth) > key
      })
    case TERM_EXTERNAL[4].id:
      const targetOneYear = getTargetMonth(legList, checkDateToDay, 12)
      return reject(legList, (data, key: number) => {
        return Number(targetOneYear) > key
      })
    case TERM_EXTERNAL[5].id:
      const targetThreeYear = getTargetMonth(legList, checkDateToDay, 36)
      return reject(legList, (data, key: number) => {
        return Number(targetThreeYear) > key
      })
    default:
      return []
  }
}
